var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-table-column",
    {
      attrs: {
        fixed: "left",
        width: "18",
        align: "right",
        "clear-padding": "left-right",
      },
    },
    [
      _c(
        "template",
        { slot: "header" },
        [
          _c(
            "yxt-dropdown",
            { attrs: { trigger: "click" }, on: { command: _vm.handleCommand } },
            [
              _c("span"),
              _c(
                "yxt-dropdown-menu",
                { attrs: { slot: "dropdown" }, slot: "dropdown" },
                [
                  _c("yxt-dropdown-item", { attrs: { command: "current" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "pc_biz_enroll_select_current_page" /* 选择本页*/
                        )
                      )
                    ),
                  ]),
                  _c("yxt-dropdown-item", { attrs: { command: "all" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("pc_biz_enroll_select_all") /* 选择全部 */)
                    ),
                  ]),
                  _c("yxt-dropdown-item", { attrs: { command: "delAll" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("pc_biz_enroll_clear_all") /*  清空所选*/)
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }